import { e as checkScriptIsLoaded, R as ResolutionStrategy, f as loadScript } from '../theme-provider/index-chunk.esm.js';

const baseUrl = 'https://maps.googleapis.com/maps/api/js?libraries=places,geometry,marker';
/**
 * Build google-maps api url to load.
 * Available parameter can be found here: https://developers.google.com/maps/documentation/javascript/load-maps-js-api#use-legacy-tag
 *
 * @param conf url configuration
 * @returns string
 */
const googleApiUrl = (conf) => {
    const { accessToken, mapId, version, locale } = conf;
    let language;
    let region;
    if (locale) {
        // eslint-disable-next-line no-useless-escape
        [, language, , , region] = /^([a-z]{2})((\-|\_)([A-Z]{2}))?$/.exec(locale) || [];
    }
    const params = {
        callback: 'googleMapsLoadedCallback',
        key: accessToken,
        map_ids: mapId,
        channel: null,
        language: `${language?.toLowerCase()}${region ? `-${region.toUpperCase()}` : ''}`,
        region: region?.toUpperCase(),
    };
    if (version !== '') {
        params.v = version || 'quarterly';
    }
    const paramStr = Object.keys(params)
        .filter((k) => params[k] !== undefined)
        .map((k) => `${k}=${params[k]}`)
        .join('&');
    return `${baseUrl}${baseUrl.indexOf('?') > 0 ? '&' : '?'}${paramStr}`;
};
const removeGoogleMapScript = () => {
    // Remove google from BOM (window object)
    window.google = undefined;
    // Remove google map scripts from DOM
    Array.prototype.slice
        .call(document.getElementsByTagName('script'))
        .filter((script) => typeof script.src === 'string' && script.src.includes('maps.googleapis'))
        .forEach((script) => script.remove());
};
const checkApiIsLoaded = () => window.google !== undefined && window.google.maps !== undefined;
const checkApiIsLoading = () => window.googleMapsLoading === true;
/**
 * Load google-maps api.
 *
 * @param reloadSDK force to reload sdk if already loaded. Useful when you want to change the locale that has been loaded.
 * @param conf the api configuration to used
 * @param resolveImmediately don't wait for google-maps callback to revolve this call.
 * @returns returns true if the api was loaded through this call, and false if the api was already loaded and not force to be reloaded.
 */
const initGoogleMapsApi = (reloadSDK, conf, resolveImmediately) => new Promise((resolve, reject) => {
    const scriptId = 'loading-google-maps';
    if (checkApiIsLoaded() && !reloadSDK) {
        resolve(false);
    }
    else if (checkApiIsLoading()) {
        checkScriptIsLoaded('google.maps', checkApiIsLoaded, checkApiIsLoading, { delay: 200, maxRetries: 100 })
            .then(() => resolve(false))
            .catch((err) => reject(err));
    }
    else {
        removeGoogleMapScript();
        window.googleMapsLoading = true;
        window.googleMapsLoadedCallback = () => {
            window.googleMapsLoading = undefined;
            if (!resolveImmediately)
                resolve(true);
        };
        const url = googleApiUrl(conf);
        const dontAskScriptLoaderToWait = ResolutionStrategy.IMMEDIATELY;
        loadScript(url, true, scriptId, dontAskScriptLoaderToWait)
            .then(() => {
            if (resolveImmediately) {
                resolve(true);
            }
        })
            .catch((err) => reject(err));
    }
});

export { initGoogleMapsApi as i };
//# sourceMappingURL=index-chunk.esm.js.map
